export default "__VITE_ASSET__CxALJfbt__"